import { View } from '@chegg/one-auth';
import { ViewQueryParam } from '@lib/constants';
import { NextRouter } from 'next/router';

export function getInitialView(router: NextRouter) {
  if (!router.query.action) return View.SIGNIN;
  switch ((router.query.action as string).toLowerCase()) {
    case ViewQueryParam.SIGNUP:
      return View.SIGNUP;
    case ViewQueryParam.FORGOT_PASSWORD:
      return View.RESET_PASSWORD;
    default:
      return View.SIGNIN;
  }
}
